<div id="tabRetInt">
    <div class="tituloInt tituloPago">{{ 'RETIRAR_O_INTRODUCIR' | translate }}</div>
    <fieldset>
      <div class="gestionInputWrap" [formGroup]="retirarForm">

        <div class="form-group" *ngIf="tienePermiso('TurnoConsultar')">
          <div class="tit-form-group">
            <label for="cambioExistente">{{ 'CAMBIO_EXISTENTE' | translate }}</label>
          </div>
          <input type="text" value="{{ cambio ? cambio.cambioResultante: 0 | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles}}" class="form-control" id="cambioExistente" [placeholder]="placeholderValue" readonly>
        </div>
        <div class="form-group" *ngIf="tienePermiso('TurnoRetirarDinero')">
          <div class="tit-form-group">
            <label for="cambioRetirar">{{ 'CAMBIO_RETIRAR' | translate }}</label>
          </div>
          <input formControlName="cambioRetirar" #cambioRetirar type="text" class="form-control" id="cambioRetirar" category="DIVISA" (focus)="focusValue($event)" [placeholder]="placeholderValue" [ngClass]="{'active-form' : isSelected(cambioRetirar)}">
        </div>
        <div class="form-group" *ngIf="tienePermiso('TurnoIntroducirDinero')">
          <div class="tit-form-group">
            <label for="cambioIntroducir">{{ 'CAMBIO_INTRODUCIR' | translate }}</label>
          </div>
          <input formControlName="cambioIntroducir" #cambioIntroducir type="text" class="form-control" id="cambioIntroducir" category="DIVISA" (focus)="focusValue($event)" [placeholder]="placeholderValue" [ngClass]="{'active-form' : isSelected(cambioIntroducir)}">
        </div>
        <div class="form-group" *ngIf="tienePermiso('TurnoConsultar')">
          <div class="tit-form-group">
            <label for="cambioResultante">{{ 'CAMBIO_RESULTANTE' | translate }}</label>
          </div>
          <input type="text" value="{{cambioResultante | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles}}" class="form-control" id="cambioResultante" [placeholder]="placeholderValue" readonly>
        </div>
        <div class="form-group textarea">
          <div class="tit-form-group">
            <label for="comentarios">{{ 'COMENTARIOS' | translate }}</label>
          </div>
          <textarea formControlName="comentarios" #comentario (focus)="focusValue($event)" category="TEXTAREA" class="form-control" rows="2" cols="40" id="comentarios" [ngClass]="{'active-form' : isSelected(comentario)}"></textarea>
        </div>

      </div>
      <div class="ButtonWrap">
        <a class="GestionarButton aceptar" [ngClass]="{'disabled': checkFormIsInvalid()}" title="{{ 'ACEPTAR' | translate }}" (click)="aplicarOperacionDeCaja()">{{ 'ACEPTAR' | translate }}</a>
      </div>

    </fieldset>
  </div>
